export enum ConfirmationDialogType {
  DELETE = 'delete',
  LEAVE = 'leave',
  JOIN = 'join',
  APPROVE_JOIN = 'approve-join',
  FORM_LEAVE = 'form-leave',
  Accept = 'accept',
  Deny = 'deny',
  APPROVE = 'approve',
  REJECT = 'reject',
  UNAPPROVE = 'unapprove',
  SHIFTS = 'shifts',
  SIMPLE_MESSAGE = 'simple-message',
  MOVE_TO_TRASH = 'move-to-trash',
  PERMANENTLY_DELETE = 'permanently-delete',
  DELETE_IMAGE = 'delete-image',
  DELETE_DOCUMENT = 'delete-document',
}
